import { render, staticRenderFns } from "./CreatorLive.vue?vue&type=template&id=8a35f9d6&"
import script from "./CreatorLive.vue?vue&type=script&lang=js&"
export * from "./CreatorLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports